import React from 'react'
import './Loading.css'

const LoadingAssessment = () => {
    return (
        <div className="loading-container">
            <div className="spinner"></div>
            <p>Starting Assessment...</p>
        </div>
    )
}

export default LoadingAssessment
